<template>
  <div class="card">
    <div class="alert alert-warning mb-0" v-if="pass == 1">
      {{ t.creating_new_password }}
    </div>
    <div class="alert alert-success mb-0" v-if="pass && pass !== 1">
      <br>{{ t.new_password }}: <b><code>{{ pass.signature }}</code></b>
    </div>
    <div class="card-header">
      {{ user.fullName }}
      <div>
        <router-link :to="{name: 'ResellerUpdate', params: {id: this.$route.params.id}}" tag="a" class="btn btn-success text-white" style="margin-top:4px">{{ t.edit }}</router-link>
        <a class="btn btn-danger customer-reset-password text-white" href="javascript:;" style="margin-top:4px" @click="regenerateUserPass(user.id)">
          {{ t.reset_password }}</a>
        <a class="btn btn-success customer-payin text-white" href="javascript:;" @click="openPayinModal(user.id, '+')" style="margin-top: 4px">
          <i class="fa fa-plus-circle"></i> {{ t.custom_reseller_panel.balance_in }}
        </a>
        <a class="btn btn-danger customer-payout text-white" href="javascript:;" style="margin-top:4px" @click="openPayinModal(user.id, '-')">
          <i class="fa fa-minus-circle"></i> {{ t.custom_reseller_panel.balance_out }}</a>

          <a class="btn btn-warning customer-payout text-white" href="javascript:;" style="margin-top:4px" @click="openStakeModal(user.id)">
          <i class="fa fa-ticket"></i> {{ t.navigation.bet_slip_limits }}
        </a>
      </div>
    </div>
    <div class="card-block p-0">
      <div class="table-responsive">
        <table class="table mb-0 info">
          <tbody>
          <tr>
            <th>{{ t.sport_giro }}:</th>
            <td><code>{{ sportGiro }}</code>
              <a href="javascript:;" class="tag tag-danger CustomerBalance" @click="userDetail">{{ t.update }}</a>
            </td>
            <th>{{ t.user.username }}:</th>
            <td>{{ user.username }}
              <strong>
                <span v-if="user.enabled">({{ t.user.enabled}})</span>
                <span v-if="!user.enabled">({{ t.user.disabled }})</span>
              </strong>
            </td>
          </tr>

          <tr>
            <th>{{ t.casino_giro }}:</th>
            <td><code>{{ casinoGiro }}</code>
              <a href="javascript:;" class="tag tag-danger CustomerBalance" @click="fetchGiro">{{ t.update }}</a>
            </td>
          </tr>
          <tr>
            <th>{{ t.user.balance }}</th>
            <td><code>{{ user.balance }}</code>
              <a href="javascript:;" class="tag tag-danger CustomerBalance" @click="fetchGiro">{{ t.update }}</a></td>
            <th>{{ t.user.last_login}}:</th>
            <td>
              <span>{{ dateTimeFormat(user.LastLogin) }}</span>
            </td>
          </tr>
          <tr>
            <th>Reference:</th>
            <td>{{ user.refUser }}</td>
            <th>{{ t.created_at }}:</th>
            <td>
              <span>{{ dateTimeFormat(user.createdAt) }}</span>
            </td>
          </tr>
          <tr>
            <th colspan="12">{{ t.details }}</th>
          </tr>
          <tr>
            <td colspan="12">{{ user.note }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <CustomerTransactions></CustomerTransactions>
    <StakeLimitModal />
  </div>
</template>

<script>

import PayinModal from "../PayinModal";
import CustomerTransactions from "../CustomerTransactions";
import StakeLimitModal from "../StakeLimitModal.vue";
export default {
  name: "ResellerInfo",
  components: {PayinModal, CustomerTransactions, StakeLimitModal},
  data() {
    return {
      user: {},
      sportGiro: 0.00,
      casinoGiro: 0.00,
      session: session,
      providers: [],
      t: this.$root.t,
      meta: null,
      pass: null
    }
  },
  mounted() {
    this.fetchGiro();
    this.userDetail();
    this.fetchMeta();
  },
  methods: {
    fetchMeta() {
      this.$http.get(api + 'api/v1/user/meta-info/' + this.$route.params.id,
          {params: this.$route.query})
          .then(response => {
            this.meta = response.body.result;
          }, response => {
          })
    },
    userDetail() {
      this.$http.get(api + 'api/v1/users?uid=' + this.$route.params.id,
          {params: this.$route.query})
          .then(response => {
            this.user = response.body.result.users[0];
          }, response => {
            this.status = response.status;
          })
    },
    openPayinModal(user, operate) {
      this.$bus.$emit('payinModal', {id: user, action: true, operate: operate})
    },
    regenerateUserPass(uid) {
      this.pass = 1;
      this.$http.post(api + 'api/v1/user/password-regeneration/' + uid)
          .then(response => {
            this.pass = response.body;

            setTimeout(() => {
              this.pass = null
            }, 10000)
          }, response => {

            this.pass = null
          })
    },
    fetchGiro(){
      this.$http.get(api + 'api/v1/reseller_giro/' + this.$route.params.id)
          .then(response => {
            this.sportGiro = response.body.result.data.bet_profit;
            this.casinoGiro = response.body.result.data.casino_profit;

          }, response => {

          })
    },
    openStakeModal(user) {
      this.$bus.$emit('openStakeModal', {id: user, action: true})
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/ResellerInfo.vue